<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');

#app {
  font-family: 'Sarabun', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.page-item.page-secondary.active .page-link {
  color: #fff; 
  background-color: #6c757d !important; 
  border-color: #6c757d !important;
}

.form-label-group {
  position: relative;
  margin-bottom: 1rem;
}

.form-label-group input,
.form-label-group label {
  height: 3.125rem;
  padding: .75rem;
}

.form-label-group select {
  height: 3.125rem;
  padding-top: .75rem;
  padding-bottom: .75rem;
}

.form-label-group select.haveData {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group select.haveData ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
  font-weight: 600;
}

.form-label-group label {
  position: absolute;
  text-align: left;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0; /* Override default `<label>` margin */
  line-height: 1.5;
  color: #8e8e8e;
  pointer-events: none;
  cursor: text; /* Match the input under the label */
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:-moz-placeholder-shown) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group input:not(:-ms-input-placeholder) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group input:not(:-moz-placeholder-shown) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
  font-weight: 600;
}

.form-label-group input:not(:-ms-input-placeholder) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
  font-weight: 600;
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
  font-weight: 600;
}

.form-label-group input:-webkit-autofill ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
  font-weight: 600;
}

/* textarea */

.form-label-group textarea::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group textarea::-moz-placeholder {
  color: transparent;
}

.form-label-group textarea:-ms-input-placeholder {
  color: transparent;
}

.form-label-group textarea::-ms-input-placeholder {
  color: transparent;
}

.form-label-group textarea::placeholder {
  color: transparent;
}

.form-label-group textarea:not(:-moz-placeholder-shown) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group textarea:not(:-ms-input-placeholder) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group textarea:not(:placeholder-shown) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group textarea:-moz-placeholder-shown {
  padding-top: .75rem;
  padding-bottom: .25rem;
}

.form-label-group textarea:-ms-input-placeholder {
  padding-top: .75rem;
  padding-bottom: .25rem;
}

.form-label-group textarea:placeholder-shown {
  padding-top: .75rem;
  padding-bottom: .25rem;
}

.form-label-group textarea:not(:-moz-placeholder-shown) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
  font-weight: 600;
}

.form-label-group textarea:not(:-ms-input-placeholder) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
  font-weight: 600;
}

.form-label-group textarea:not(:placeholder-shown) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
  font-weight: 600;
}

.form-label-group textarea:-webkit-autofill ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
  font-weight: 600;
}

/* Fallback for Edge
-------------------------------------------------- */
@supports (-ms-ime-align: auto) {
  .form-label-group {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column-reverse;
    flex-direction: column-reverse;
  }

  .form-label-group label {
    position: static;
  }

  .form-label-group input::-ms-input-placeholder {
    color: #777;
    font-weight: 600;
  }

  .form-label-group textarea::-ms-input-placeholder {
    color: #777;
    font-weight: 600;
  }
}

.pt-50px-md{
  padding-top: 3px;
}

/* @media only screen and (min-width: 576px) {
  .pt-50px-md{
    padding-top: 5px;
  }
} */

.chb-2x .custom-control {
  padding-left: 1.75rem;
}

.chb-2x .custom-control-label::after {
  width: 1.4rem;
  height: 1.4rem;
  top: .1rem;
  left: -1.75rem;
}

.chb-2x .custom-control-label::before {
  width: 1.5rem;
  height: 1.5rem;
  top: .05rem;
  left: -1.75rem;
}

.chb-2x .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff;
  width: 1.5rem;
  height: 1.5rem;
  top: .05rem;
  left: -1.75rem;
}

.chb-2x .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  width: 1.4rem;
  height: 1.4rem;
  top: .1rem;
  left: -1.75rem;
}

.no-browse {
  /* margin-bottom: 1rem; */
  height: 3rem;
}

.no-browse .custom-file-label {
  border-width:3px;  
  border-style:dashed;
  height: 3rem;
  padding: .6rem;
}

.no-browse .custom-file-input ~ .custom-file-label[data-browse]::after {
  display: none;
}

.lb-topic {
  font-weight: 600;
  margin-bottom: 5px;
}

.swal2-modal {
  font-family: 'Sarabun', sans-serif !important;
}

.swal2-input[type=number] {
    max-width: 15em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue